import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';
import { JOIN_REQUEST_RESOURCE } from '../../constants';

import apiRoutes from '../../../../app/api/routes';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: JOIN_REQUEST_RESOURCE,
      method: 'get',
      request: (orgId, id, rejectCallback, t) => ({
        url: apiRoutes.principalJoinRequests(orgId, id),
        meta: {
          rejectCallback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getJoinRequestFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);
